import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteSelectorComponent } from '@shared/components/autocomplete-selector/autocomplete-selector.component';
import { TopOfBookSource } from '@api/core';
import { matchText } from '@shared/utils/strings';
import { isString } from 'lodash';
import { Maybe } from '@stillmandigital/common';
import { AsyncPipe } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-source-selector',
  imports: [
    AsyncPipe,
    MatFormField,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatIconButton,
    MatIcon,
    MatAutocomplete,
    MatOption,
    MatInput,
    MatLabel,
    MatSuffix,
    MatTooltip,
  ],
  templateUrl: './source-selector.component.html',
  styleUrl: './source-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SourceSelectorComponent),
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SourceSelectorComponent),
      multi: true,
    },
  ],
})
export class SourceSelectorComponent extends AutocompleteSelectorComponent<TopOfBookSource> {
  public matchOption(source: TopOfBookSource, value: string): boolean {
    return (
      matchText(source.pair?.name, value) ||
      matchText(source.name, value) ||
      matchText(`[${source.pair?.name}] ${source.name}`, value)
    );
  }

  public displayOption(source: string | TopOfBookSource): string {
    return isString(source) ? source : getSourceName(source);
  }

  public extractId(option: Maybe<TopOfBookSource>): string | number | undefined {
    return option?.id;
  }

  public label = input<Maybe<string>>('Source');
}

function getSourceName(source: TopOfBookSource): string {
  return source?.pair?.name && source?.name ? `[${source?.pair?.name}] ${source?.name}` : '';
}
